import React from 'react';
import { useLocalization } from '../../utils/hooks/useLocalization'
import styles from './ArtistsPage.module.css';
import artists from "../../data/artist";

const ArtistCard = ({ artist, isMobile }) => {
  const { currentLanguage, t } = useLocalization();
  return (
  <>
    <div className={styles.artistImageContainer}>
      <img
        src={require('../../../images/' + artist.id_photos[0])}
        alt={artist.nickName}
        className={isMobile && artist.active ? styles.artistImageMobile : styles.artistImage} />
    </div>
    <div className={isMobile ? styles.infoBoxMobile : styles.infoBox}>
      <h2 className={styles.artistNickname}>{artist.nickName}</h2>
      <h4 className={styles.artistName}>{artist.name}</h4>
      <p className={styles.artistBio}>{artist.bio[currentLanguage]}</p>
      {isMobile && artist.active && <a href={artist.active ? `artist/${artist.id}` : undefined} className={styles.ctaBtnContainer}>
        <button className={styles.ctaBtn}>
          {t('artists_action_view')}
        </button>
      </a>}
    </div>
  </>);
}


const ArtistsPage = ({ isMobile }) => {
  const { currentLanguage } = useLocalization();

  const shownArtists = artists.items.filter(artist => artist.show);

  
  const getArtistCardClasses = (index, isActive) => {
    const baseClasses = isMobile ?
      (index % 2 === 0 ? styles.artistCardMobile : styles.artistCardReversedMobile) :
      (index % 2 === 0 ? styles.artistCard : styles.artistCardReversed)
    return isActive && !isMobile ? `${baseClasses} ${styles.active}` : baseClasses;
  }

  return (
    <section id="products" className={styles.artists}>
        <div className={styles.container}>
        {/* Section Header */}
          <div className={styles.header}>
            <h2 className={styles.title}>
              <span className={styles.titleMain}>OUR</span>
              <span className={styles.titleAccent}>ARTISTS</span>
            </h2>
          </div>
          <div className={styles.artistsWrapper}>
            {shownArtists.map((artist, index) =>
            isMobile ? <div
              className={getArtistCardClasses(index, artist.active)} key={artist.id}>
              <ArtistCard artist={artist} isMobile={isMobile} />
            </div> :
            <a
              href={artist.active ? `artist/${artist.id}` : undefined}
              className={getArtistCardClasses(index, artist.active)} key={artist.id}>
              <ArtistCard artist={artist} isMobile={isMobile} />
            </a>
            )}
          </div>
        </div>
      </section>
  );
};

export default ArtistsPage;